export default __webpack_public_path__ + "static/media/logo.f72ffcb6.svg";